import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, HelpCircle } from 'lucide-react';
import Button from '../ui/Button';

interface HelpArticleProps {
  title: string;
  category: string;
  content: React.ReactNode;
  relatedArticles?: { title: string; link: string }[];
}

const HelpArticle: React.FC<HelpArticleProps> = ({ title, category, content, relatedArticles = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-8 sm:px-6 lg:px-8">
          <button onClick={() => navigate(-1)} className="inline-flex items-center text-green-600 hover:text-green-700 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Tilbage til Hjælpecenter
          </button>
          <div className="text-sm text-gray-500 mb-2">{category}</div>
          <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
        </div>
      </div>

      {/* Content */}
      <div className="py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
              <div className="article-content">
                {content}
              </div>
            </div>

            {/* Related Articles */}
            {relatedArticles.length > 0 && (
              <div className="mt-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Relaterede artikler</h2>
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 divide-y divide-gray-200">
                  {relatedArticles.map((article) => (
                    <Link
                      key={article.title}
                      to={article.link}
                      className="block p-4 hover:bg-gray-50 transition-colors"
                    >
                      <div className="flex items-center text-gray-700 hover:text-green-600">
                        <HelpCircle className="h-5 w-5 mr-3 flex-shrink-0" />
                        <span>{article.title}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {/* Contact Support */}
            <div className="mt-8 bg-green-50 rounded-lg p-6 text-center">
              <h3 className="text-lg font-medium text-gray-900 mb-2">Fandt du ikke hvad du ledte efter?</h3>
              <p className="text-gray-600 mb-4">Vores supportteam er klar til at hjælpe</p>
              <Link to="/contact">
                <Button variant="primary">
                  Kontakt Support
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpArticle;
